// "Add a gift note" on a basket line (snippets/pp-cart-gift-note.liquid). Document-delegated, because the slide-out basket
// re-renders its lines. Rewrites the line's properties with one /cart/change.js call, keeping everything Globo put there.
(function () {
  if (window.ppGiftNoteReady) return;
  window.ppGiftNoteReady = true;
  var MAX = 250, dlg, ta, count, err, save, cur;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'pp-gn';
    dlg.setAttribute('aria-labelledby', 'pp-gn-t');
    dlg.innerHTML = '<form method="dialog"><h2 id="pp-gn-t" class="pp-gn__t">Your gift note</h2>'
      + '<label class="visually-hidden" for="pp-gn-ta">Gift note</label>'
      + '<textarea id="pp-gn-ta" rows="4" maxlength="' + MAX + '" placeholder="e.g. Happy birthday Sam, one for the reading nook! Love, Jo"></textarea>'
      + '<p class="pp-gn__hint">Printed on a card and packed with your poster. <span data-c></span> characters left.</p>'
      + '<p class="pp-gn__err" role="alert" hidden>That did not save. Please try again.</p>'
      + '<div class="pp-gn__row"><button type="button" class="pp-gn__cancel" data-x>Cancel</button><button type="button" class="pp-gn__save" data-s>Save gift note</button></div></form>';
    document.body.appendChild(dlg);
    ta = dlg.querySelector('textarea'); count = dlg.querySelector('[data-c]'); err = dlg.querySelector('.pp-gn__err'); save = dlg.querySelector('[data-s]');
    ta.addEventListener('input', function () { count.textContent = String(MAX - ta.value.length); });
    dlg.querySelector('[data-x]').addEventListener('click', function () { dlg.close(); });
    save.addEventListener('click', submit);
  }

  function submit() {
    var key = cur.getAttribute('data-pp-gn'), note = ta.value.trim(), btn = cur;
    save.disabled = true; err.hidden = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line) throw new Error('line gone');
      var props = {}, sp = line.properties || {};
      Object.keys(sp).forEach(function (k) { if (k !== 'Gift note' && sp[k] != null && sp[k] !== '') props[k] = sp[k]; });
      if (note) props['Gift note'] = note;
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: line.quantity, properties: props }) });
    }).then(function (r) {
      if (!r.ok) throw r;
      dlg.close();
      // Same refresh as the basket's "Add a frame": in place in the slide-out, a reload on the basket page.
      if (btn.closest('[data-pp-cd]') && window.ppCartDrawer) window.ppCartDrawer.open(false);
      else window.location.reload();
    }).catch(function () { err.hidden = false; }).then(function () { save.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-gn]');
    if (!b) return;
    e.preventDefault();
    if (!dlg) build();
    cur = b;
    ta.value = b.getAttribute('data-note') || '';
    count.textContent = String(MAX - ta.value.length);
    err.hidden = true;
    dlg.showModal();
    ta.focus();
  });
})();
